import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Link, matchRoutes, useLocation } from 'react-router-dom';
import { ThemeProvider, ThemeContext } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { Media } from '../../../../theme/Media.js';
import { Tooltip } from '../../../Feedback/Tooltip/index.js';
import { palette } from '../../../Palette/index.js';
import { usePuzzleNavigationContext } from '../context.js';
import { CornerBadge } from './CornerBadge.js';
import { HeaderWrapper } from './Item/HeaderWrapper.js';
import { ItemElement, ItemHeader } from './Item/styled.js';
const ItemLink = ({ icon, title, exact, path: pathProp, to, dataTestId, label, theme, ribbon, showIndicator }) => {
    const { setActiveKey, isCollapsedNav, collapseMainNav } = usePuzzleNavigationContext();
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const currentTheme = useContext(ThemeContext);
    const effectiveTheme = theme ?? currentTheme ?? palette.primary;
    const handleCloseMenu = useCallbackRef(() => {
        setActiveKey(null);
        if (to && isMobile) {
            collapseMainNav();
        }
    });
    const location = useLocation();
    const paths = useMemo(() => (Array.isArray(pathProp) ? pathProp : [pathProp]).map((path) => ({
        path: exact ? path : `${path}/*`,
    })), [exact, pathProp]);
    const match = useMemo(() => matchRoutes(paths, location), [location, paths]);
    return (_jsx(ThemeProvider, { theme: effectiveTheme, children: _jsx(Tooltip, { tooltip: title, placement: 'right', ContainerComponent: ItemElement, disabled: !isCollapsedNav, zIndex: 11, children: _jsxs(ItemHeader, { as: Link, $collapsed: isCollapsedNav, onClick: handleCloseMenu, to: to, "data-testid": dataTestId, children: [ribbon && _jsx(CornerBadge, { variant: ribbon }), _jsx(HeaderWrapper, { title: title, match: !!match, icon: icon, label: label, showIndicator: showIndicator })] }) }) }));
};
export default memo(ItemLink);
